(() => {
  const selectors = {
    benefitAndImageItem: 'benefit-and-image-item',
    section: '.benefits-and-image',
    descriptionWrapper: '.benefits-and-image__content-item-description-wrapper',
    description: '.benefits-and-image__content-item-description',

    showOnlyOpenBenefit: 'showOnlyOneOpenBenefit',
    benefitAndImageItemActiveClass: 'benefits-and-image__content-item--active',
  };

  class BenefitAndImageItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.dataset.initialized) return;

      this.dataset.initialized = "true";
      this.addEventListener('click', this.handleClick);
      this.initActiveElementHeight();
    };

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    };

    handleClick(event) {
      const item = event.currentTarget.closest(selectors.benefitAndImageItem);
      const currentSection = item.closest(selectors.section);
      const dataShowOnlyOpenBenefit = item.dataset[selectors.showOnlyOpenBenefit];
      const descriptionWrapper = item.querySelector(selectors.descriptionWrapper);
      const description = item.querySelector(selectors.description);

      if (dataShowOnlyOpenBenefit === 'true') {
        const allActiveItems = currentSection.querySelectorAll(`.${selectors.benefitAndImageItemActiveClass}`);

        allActiveItems.forEach((activeItem) => {
          if (activeItem === item) return;

          const descriptionWrapper = activeItem.querySelector(selectors.descriptionWrapper);

          descriptionWrapper.style.height = '0px';
          activeItem.classList.remove(selectors.benefitAndImageItemActiveClass);
        });
      }

      if (item.classList.contains(selectors.benefitAndImageItemActiveClass)) {
        const descriptionHeight = description.scrollHeight;

        descriptionWrapper.style.height = `${descriptionHeight}px`;
        descriptionWrapper.style.height = '0px';
        item.classList.remove(selectors.benefitAndImageItemActiveClass);

      } else {
        const descriptionHeight = description.scrollHeight;

        descriptionWrapper.style.height = `${descriptionHeight}px`;
        item.classList.add(selectors.benefitAndImageItemActiveClass);
      }
    };


    initActiveElementHeight() {
      const currentSection = this.closest(selectors.section);

      if (!currentSection) return;

      const firstActiveElement = currentSection.querySelector(`.${selectors.benefitAndImageItemActiveClass}`);

      if (!firstActiveElement) return;

      if (firstActiveElement === this) {
        const descriptionWrapper = this.querySelector(selectors.descriptionWrapper);
        const description = this.querySelector(selectors.description);

        if (descriptionWrapper && description) {
          descriptionWrapper.style.height = `${description.scrollHeight}px`;
        }
      }
    };
  }

  if (!customElements.get(selectors.benefitAndImageItem)) {
    customElements.define(selectors.benefitAndImageItem, BenefitAndImageItem);
  }
})();
